import utils from './utils'

let locateInstance = null
let locateComplete = false
let timerHandle = null

// 处理地图返回的城市名称
// 直辖市 自治区 情况下 城市名称与正常的省份有区别
// @param address {Object}
// @return {Object}
const handleAddressComponent = function (address) {
  let { city, province, district } = address
  if (!city) {
    city = province
  }
  if (city === province) {
    const zCity = ['上海市', '北京市', '重庆市', '天津市']
    if (zCity.every(x => x !== city)) {
      // 自治区
      city = district
    }
  }
  return {
    ...address,
    city
  }
}

const geoSearch = function(lnglatArr) {
  return new Promise((res, rej) => {
    AMap.service('AMap.Geocoder', () => {
      new AMap.Geocoder({ city: '010' }).getAddress(lnglatArr, (status, result) => {
        if (status === 'complete' && result.info === 'OK') {
          const format = handleAddressComponent(result.regeocode.addressComponent)
          session(format)
          res(format)
        } else {
          locateError(rej, 'AMap.Geocoder 查询失败')
        }
      })
    })
  })
}

// 最终的数据处理
const doLocateRes = function(data) {
  // 校验结果的准确性
  const { adcode, lat, lng } = data
  if (adcode) {
    const format = handleAddressComponent(data)
    session(data)
    return Promise.resolve(format)
  } else if (window.AMap) {
    // 未返回城市，利用高德API获取
    return geoSearch([lng, lat]).then(res => ({ ...res, lng, lat }))
  } else {
    return locateError(null, 'AMap全局未注册，请引入高德SDK')
  }
}

const session = function (param) {
  if (param instanceof Object) {
    sessionStorage.setItem('locate-address', JSON.stringify(param))
  } else {
    const item = sessionStorage.getItem('locate-address')
    return item ? JSON.parse(item) : null
  }
}

const locateError = function (reject, msg = '定位失败，请重试') {
  const obj = { code: 400, msg }
  if (reject) {
    reject(obj)
  } else {
    return Promise.reject(obj)
  }
}

const timeout = function (reject, delayTimeout) {
  timerHandle = setTimeout(()=> {
    if (!locateComplete) {
      locateError(reject, '定位超时')
    }
  }, delayTimeout)
}

// @params ignore {Boolearn} ignore 不采用location.search中的经纬度
// @params options {Object} 包含以下可选参数
// @params options.sdk {Number} 用什么sdk定位
// 0 => 高德地图(默认)   1 => 百度地图
// @params options.location {Number} 用什么坐标系
// 0 => 高德 (默认)  1 => 百度
// @params options.timeout {Number} 超时时间(s)
// locateHandleTimer = null
export default function(options = {}) {
  const sessionLocate = session()
  let mergeOptions = {
    sdk: 0,
    location: 0,
    category: 0,
    timeout: 1,
    // timeout
    // 在部分安卓上 很小时，不能定位成功
    // 在iOS上必须设置为小于等于5的数 才能定位成功
    // 默认针对系统设置timeout的大小
    timeoutHack: true,
    accuracy: 100,
    delayTimeout: 10 * 1000,
    ...options
  }

  if (mergeOptions.timeoutHack) {
    mergeOptions.timeout = utils.isIOS ? 1 : 5000
  }

  // 实例存在
  if (locateInstance) {
    console.log('locate instance is exist')
    return locateInstance
  }

  locateInstance = new Promise((resolve, reject)=> {
    timeout(reject, mergeOptions.delayTimeout)

    // session不存在 或 强制定位
    if (options.force || !sessionLocate) {
      locateComplete = false

      return this.native('getlocation', mergeOptions).then(res => {
        locateComplete = true
        timerHandle && clearTimeout(timerHandle)

        if (
          res.code === 200 &&
          res.data &&
          res.data.lat &&
          res.data.lng
        ) {
          resolve(doLocateRes(res.data))
        } else {
          locateError(reject)
        }
      })
    } else {
      locateComplete = true
      timerHandle && clearTimeout(timerHandle)
      resolve(sessionLocate)
    }
  }).finally(() => {
    locateInstance = null
  })

  return locateInstance
}
